import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  inputStyles,
} from "../../../constants/Styles";

export const DateInputContainer = styled.div`
  ${inputStyles};
  justify-content: space-between;
  align-items: center;
  min-width: 12rem;
  gap: 0.5rem;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${FONT_SIZE.size18};
  font-family: ${FONTS.spaceGrotesk};
`;

export const DateHeader = styled.div`
  font-weight: ${FONT_WEIGHT.weight700};
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.secondaryLight};
`;

function getBackgroundColor(backgroundColor?: string) {
  if (backgroundColor !== undefined) {
    return backgroundColor;
  }
  return "inherit";
}

const getBorder = (selected?: boolean, today?: boolean) => {
  if (today) {
    return `2px ${COLORS.secondaryLight} solid`;
  }
  if (selected) {
    return `2px ${COLORS.secondary} solid`;
  }
  return "none";
};

export const DateCell = styled.div<{
  today?: boolean;
  selectable?: boolean;
  selected?: boolean;
  backgroundColor?: string;
}>`
  cursor: ${({ selectable }) => (selectable ? "pointer" : "inherit")};
  width: 2rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  text-decoration: ${({ selectable }) =>
    selectable ? "inherit" : "line-through"};
  border: ${({ selected, today }) => getBorder(selected, today)};
  color: ${({ selectable }) =>
    selectable ? COLORS.secondary : COLORS.secondaryLight};
  background-color: ${({ backgroundColor }) =>
    getBackgroundColor(backgroundColor)};
`;

export const LegendTitle = styled.div`
  text-align: center;
  font-size: ${FONT_SIZE.size18};
  font-family: ${FONTS.spaceGrotesk};
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LegendRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FlashPCBCalendarContainer = styled.div`
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
